module.exports = __webpack_public_path__ + "static/media/icon-html5.4e6a0efb.svg";